export default "__VITE_ASSET__028358e6__"